
import normalizeWheel from 'normalize-wheel';
import onVisibilityChange from "visibility-change-ponyfill";

const events=new WeakMap();
function mouseWheelCallback(callback){
  return function(event){
    const normalized = normalizeWheel(event);
    callback && callback.apply(this, [event, normalized]);
  }
}
export default {
  //附加鼠标滚轮
  addMouseWheelEvent(el, callback) {
    if (el) {
      let isFirefox = dsf.client.type == 'FF';
      events.set(callback,mouseWheelCallback(callback));
      el.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel',events.get(callback));
    }
  },
  removeMouseWheelEvent(el,callback) {
    if (el) {
      let isFirefox = dsf.client.type == 'FF'
      el.removeEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', events.get(callback));
      events.set(callback,null);
      events.delete(callback)
      // callback=null;
    }
  },
  addVisiblityChangeEvent(callback){
    onVisibilityChange(callback)
  },
  removeVisiblityChangeEvent(callback){
    onVisibilityChange.remove(callback)
    callback=null;
  }
}